import './loader.scss';
import Loader from '../../../assets/images/loaders/loader.gif';

import React from 'react';
import { useAppSelector } from '../../../features';
import { getLoaderSatus } from '../../../store/LoaderSlice';

export const GlobalLoader : React.FC = () => {

    const loaderStatus = useAppSelector(getLoaderSatus);

    return (
        <div className={`loader ${loaderStatus ? 'show' : 'hide'}`}>
            <img src={Loader} alt="" />
        </div>
    )
}

export const TRKLoader: React.FC = () => {
    return (
        <>
            <div className="loaderTrk">

                <svg height="0" width="0" viewBox="0 0 64 64" className="absolute">
                    <defs className="s-xJBuHA073rTt" xmlns="http://www.w3.org/2000/svg">
                        <linearGradient className="s-xJBuHA073rTt" gradientUnits="userSpaceOnUse" y2="2" x2="0" y1="62" x1="0" id="b">
                        <stop className="s-xJBuHA073rTt" stopColor="#973BED"></stop>
                        <stop className="s-xJBuHA073rTt" stopColor="#007CFF" offset="1"></stop>
                        </linearGradient>
                        <linearGradient className="s-xJBuHA073rTt" gradientUnits="userSpaceOnUse" y2="0" x2="0" y1="64" x1="0" id="c">
                        <stop className="s-xJBuHA073rTt" stopColor="#FFC800"></stop>
                        <stop className="s-xJBuHA073rTt" stopColor="#F0F" offset="1"></stop>
                        <animateTransform repeatCount="indefinite" keySplines=".42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1" keyTimes="0; 0.125; 0.25; 0.375; 0.5; 0.625; 0.75; 0.875; 1" dur="8s" values="0 32 32;-270 32 32;-270 32 32;-540 32 32;-540 32 32;-810 32 32;-810 32 32;-1080 32 32;-1080 32 32" type="rotate" attributeName="gradientTransform"></animateTransform>
                        </linearGradient>
                        <linearGradient className="s-xJBuHA073rTt" gradientUnits="userSpaceOnUse" y2="2" x2="0" y1="62" x1="0" id="d">
                        <stop className="s-xJBuHA073rTt" stopColor="#00E0ED"></stop>
                        <stop className="s-xJBuHA073rTt" stopColor="#00DA72" offset="1"></stop>
                        </linearGradient>
                    </defs>
                </svg>
                <svg fill="none" viewBox="15 15 120 120" height="64" width="64" className="inline-block"><path strokeLinejoin="round" strokeLinecap="round" strokeWidth="4" stroke="url(#b)" className="dash" id="o" pathLength="360" d="M111.84 15.36H16.16c-1.24 0-2.24 1-2.24 2.24v17.99c0 1.24 1 2.24 2.24 2.24h34.65v80.73c0 1.24 1 2.24 2.24 2.24h21.9c1.24 0 2.24-1 2.24-2.24V37.83h34.65c1.24 0 2.24-1 2.24-2.24V17.6c0-1.24-1-2.24-2.24-2.24z"></path></svg>  
                <svg fill="none" viewBox="15 15 120 120" height="64" width="64" className="inline-block"><path strokeLinejoin="round" strokeLinecap="round" strokeWidth="4" stroke="url(#c)" className="dash" id="o" pathLength="360" d="M110.7 117.03L85.59 83.64c13.01-5.37 22.18-18.08 22.18-32.87c0-19.63-16.13-35.61-35.96-35.61H33.95c-.15 0-.28.06-.42.09h-6.46c-1.24 0-2.24 1-2.24 2.24v100.96c0 1.24 1 2.24 2.24 2.24h21.89c1.24 0 2.24-1 2.24-2.24V86.37h8.64l25.2 33.51c.45.59 1.15.94 1.89.94h21.89c.9 0 1.72-.51 2.11-1.31c.4-.8.31-1.76-.23-2.48zM70.12 65.38c-.36.03-.72.06-1.08.06H51.57c-.05 0-.09-.04-.14-.06c-.09-.02-.18-.04-.24-.1a.577.577 0 0 1-.21-.43V36.67c0-.17.08-.32.21-.43c.06-.05.14-.07.22-.09c.06-.02.1-.07.16-.07h17.46c.42 0 .84.03 1.25.07c7.22.66 12.9 6.96 12.9 14.61c.01 7.72-5.76 14.04-13.06 14.62z" ></path></svg>
                <svg fill="none" viewBox="15 15 120 120" height="64" width="64" className="inline-block"><path strokeLinejoin="round" strokeLinecap="round" strokeWidth="4" stroke="url(#d)" className="dash" id="o" pathLength="360"  d="M110.55 117.41L76.92 63.69l29.73-44.82c.45-.69.5-1.57.1-2.3a2.222 2.222 0 0 0-1.97-1.18H80.34c-.74 0-1.45.38-1.86 1L51.49 57.08V17.64c0-1.24-1.01-2.24-2.24-2.24h-21.9c-1.24 0-2.24 1-2.24 2.24V118.6c0 1.24 1 2.24 2.24 2.24h21.9c1.23 0 2.24-1 2.24-2.24V70.55l30.82 49.24c.41.65 1.13 1.05 1.9 1.05h24.44c.81 0 1.57-.44 1.96-1.16c.39-.71.37-1.58-.06-2.27z"></path></svg>
            </div>
        </>
    )
}

export const DotLoader: React.FC = () => {
    return (
        <section className="dots-container">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
        </section>
    )
}

export const PaymentLoader: React.FC = () => {
    return (
        <div className="banter-loader-wrapper">
            <div className="banter-loader">
                <div className="banter-loader__box"></div>
                <div className="banter-loader__box"></div>
                <div className="banter-loader__box"></div>
                <div className="banter-loader__box"></div>
                <div className="banter-loader__box"></div>
                <div className="banter-loader__box"></div>
                <div className="banter-loader__box"></div>
                <div className="banter-loader__box"></div>
                <div className="banter-loader__box"></div>
            </div>
        </div>
    )
}